"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.init = init;
var selectors = {
    form: "[data-footer-form]",
    thankYou: "[data-email-thank-you]"
};

function init() {
    showThankYou();
}

function showThankYou() {
    var form = document.querySelector(selectors.form);
    var thankYou = document.querySelector(selectors.thankYou);
    var hash = window.location.hash;
    if (hash === "#email-thank-you") {
        form.classList.add("hidden");
        thankYou.classList.remove("hidden");
    }
}